export default __webpack_public_path__ + "static/media/icon-select.45530a7e.svg";